<template>
  <div class="p-20">
    <vx-card>
      <h5 class="pl-20">กรุณากรอกหมายเลขโทรศัพท์ที่ใช้งาน (10 หลัก)</h5>
      <div class="vx-row mt-10">
        <div class="vx-col w-full" align="center">
          <vs-input id="card_id" class="w-1/3" v-model="phoneNumber" disabled />
          <vs-button
            icon-pack="feather"
            icon="icon-call"
            class="my-5"
            color="primary"
            @click="requestOTP()"
          >
            <span class="d-none d-sm-block">ขอหมายเลข OTP</span>
          </vs-button>
          <span class="text-danger"
            >***** หมายเหตุ ใส่หมายเลขโทรศัพท์ เช่น +66 {{phoneNumber}} *****</span
          >
        </div>
      </div>
      <vs-divider position="center"></vs-divider>
      <div class="pl-20">
        <h5 class="mb-2 mt-5">กรอกหมายเลข OTP (6 หลัก) ที่ได้รับจาก SMS</h5>
        <h5>จากหมายเลขโทรศัพท์ +66 {{phoneNumber}}</h5>
      </div>
      <div align="center" class="mt-5">
        <vs-row
          class="pr-20 pl-20"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
        >
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
            <vs-input
              id="otp1"
              class="otp1 w-1/2 mr-2"
              maxlength="1"
              v-model="otp1"
            />
            <h1 class="mr-2">-</h1>
            <vs-input
              id="otp2"
              class="w-1/2 mr-2"
              maxlength="1"
              v-model="otp2"
            />
            <h1 class="mr-2">-</h1>
            <vs-input
              id="otp3"
              class="w-1/2 mr-2"
              maxlength="1"
              v-model="otp3"
            />
            <h1 class="mr-2">-</h1>
            <vs-input
              id="otp4"
              class="w-1/2 mr-2"
              maxlength="1"
              v-model="otp4"
            />
            <h1 class="mr-2">-</h1>
            <vs-input
              id="otp5"
              class="w-1/2 mr-2"
              maxlength="1"
              v-model="otp5"
            />
            <h1 class="mr-2">-</h1>
            <vs-input
              id="otp6"
              class="w-1/2 mr-2"
              maxlength="1"
              v-model="otp6"
            />
          </vs-col>
        </vs-row>
        <vs-button class="mt-5 mb-5" color="primary" @click="validateOTP()">
          <span class="d-none d-sm-block">ยืนยัน OTP</span>
        </vs-button>
      </div>
    </vx-card>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import { ENDPOINT } from "../../constants/endpoint";

export default {
  data() {
    return {
      phoneNumber: sessionStorage.getItem("phoneNumber"),
      otp1: "",
      otp2: "",
      otp3: "",
      otp4: "",
      otp5: "",
      otp6: "",
      token: null,
    };
  },
  mounted() {
    console.log(" phone ", sessionStorage.getItem("phoneNumber"));
    // console.log("this.phoneNumber ", this.phoneNumber);
    this.phoneNumber = this.formatePhoneNumber(this.phoneNumber)
    $(document).ready(function() {
      $("#otp1 , #otp2, #otp3 , #otp4, #otp5 , #otp6").bind("keypress", function(evt) {
        var key = String.fromCharCode(evt.which || evt.charCode);
        if (/[\d]/.test(key) === false) return evt.preventDefault();
      });
    });
  },
  methods: {
    requestOTP() {
      if (this.phoneNumber == "" || undefined) {
        Swal.fire({
          icon: "error",
          title: "กรุณากรอกหมายเลขโทรศัพท์",
          showConfirmButton: false,
          timer: 2000,
        });
      } else {
        let payload = {
          phoneNumber: sessionStorage.getItem("phoneNumber"),
        };
        axios
          .post(ENDPOINT.REQUEST_OTP, payload)
          .then((response) => {
            console.log(response.data);
            if (response.data.code == 400) {
              Swal.fire({
                icon: "error",
                title: "หมายเลขโทรศัพท์ไม่ถูกต้อง",
                showConfirmButton: false,
                timer: 2000,
              });
            } else {
              this.token = response.data;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    validateOTP() {
      if (
        this.otp1 == "" ||
        this.otp2 == "" ||
        this.otp3 == "" ||
        this.otp4 == "" ||
        this.otp5 == "" ||
        this.otp6 == ""
      ) {
        Swal.fire({
          icon: "warning",
          title: "กรุณากรอกหมายเลข OTP ให้ครบ",
          showConfirmButton: false,
          timer: 2000,
        });
      } else {
        let OTP = `${this.otp1}${this.otp2}${this.otp3}${this.otp4}${
          this.otp5
        }${this.otp6}`;

        let payload = {
          token: this.token.data.token,
          otp: OTP,
          userId: sessionStorage.getItem("userID"),
        };
        console.log("this is OTP : ", OTP);
        console.log("this is payload :", payload);
        axios
          .put(ENDPOINT.VERIFY_OTP, payload)
          .then((response) => {
            // console.log("this is check OTP :", response);
            if (response.status == 400) {
              Swal.fire({
                icon: "warning",
                title: `${response.data.message}`,
                showConfirmButton: false,
                timer: 2000,
              });
            } else {
              Swal.fire({
                icon: "success",
                title: "OTP ถูกต้อง",
                showConfirmButton: false,
                timer: 1500,
                showLoaderOnDeny: true,
              }).then(() => {
                sessionStorage.removeItem("userID");
                sessionStorage.removeItem("phoneNumber");
                this.$router.push("/dashboard");
              });
            }
          })
          .catch((error) => {
            console.log(error);
            Swal.fire({
              icon: "error",
              title: "เกิดข้อผิดพลาด",
              showConfirmButton: false,
              timer: 2000,
            });
          });
      }
    },
    formatePhoneNumber(phoneNumber){
      return phoneNumber && `${phoneNumber.substring(0,1)}${phoneNumber.substring(1,2)}-XXXX-${phoneNumber.substring(6,7)}${phoneNumber.substring(7,8)}${phoneNumber.substring(8,9)}${phoneNumber.substring(9,10)}`
    }
  },
  watch: {
    otp1: function() {
      document.getElementById("otp2").focus();
    },
    otp2: function() {
      document.getElementById("otp3").focus();
    },
    otp3: function() {
      document.getElementById("otp4").focus();
    },
    otp4: function() {
      document.getElementById("otp5").focus();
    },
    otp5: function() {
      document.getElementById("otp6").focus();
    },
  },
};
</script>

<style lang="css" scoped></style>
